import type { SxStyle } from '@aibees/shared/theme';

export const root: SxStyle = {
  borderWidth: '1px',
  borderStyle: 'solid',
  borderColor: (p) => p.palette.primary[100],
  borderRadius: (p) => p.spacing(1.5),
  overflow: 'hidden',
  width: '100%',
};

export const header: SxStyle = {
  color: (p) => p.palette.primary[600],
  background: (p) => p.palette.common.white,
  px: 2,
  py: 1.5,
  borderBottomWidth: '1px',
  borderBottomStyle: 'solid',
  borderBottomColor: (p) => p.palette.primary[100],
  fontSize: (p) => p.typography.body1.fontSize,
  fontWeight: (p) => p.typography.fontWeightSemiBold,
};

export const costTitle: SxStyle = {
  fontSize: (p) => p.typography.body2.fontSize,
  color: (p) => p.palette.grey[500],
};

export const cost: SxStyle = {
  fontSize: (p) => p.typography.body2.fontSize,
  fontWeight: (p) => p.typography.fontWeightBold,
  color: (p) => p.palette.primary[600],
};
